<template>
    <div>
        <div class="uk-grid table-filter">
            <div class="uk-width-1-4@xl uk-width-1-2@s  uk-margin-small-bottom">
                <label for="pf-search" class="uk-form-label">Search</label>
                <div class="uk-form-controls">
                    <input
						id="pf-search"
						type="text"
						name="pf-search"
						value=""
						class="uk-input"
						v-model="searchTerm"
						@keydown="checkSearch"
						placeholder="Enter Search Terms"
					/>
                </div>
                <div v-if="!activeSearch" class="uk-form-label uk-margin-top">Narrow Search By</div>
                <div v-if="!activeSearch" class="uk-margin uk-grid-medium uk-child-width-auto uk-grid">
                    <label>
                        Name
                        <input class="uk-checkbox" type="checkbox" value="name" v-model="checkedFilters" />
                    </label>
                    <label>
                        Employee #
                        <input class="uk-checkbox" type="checkbox" value="emp" v-model="checkedFilters" />
                    </label>
                    <label>
                        Craft
                        <input class="uk-checkbox" type="checkbox" value="craft" v-model="checkedFilters" />
                    </label>
                    <label>
                        Certification
                        <input class="uk-checkbox" type="checkbox" value="certification" v-model="checkedFilters" />
                    </label>
                    <label>
                        Training
                        <input class="uk-checkbox" type="checkbox" value="training" v-model="checkedFilters" />
                    </label>
                    <label>
                        Phone #
                        <input class="uk-checkbox" type="checkbox" value="phone" v-model="checkedFilters" />
                    </label>
                    <label>
                        Include Deleted
                        <input class="uk-checkbox" type="checkbox" value="include_deleted" v-model="checkedFilters" />
                    </label>
                </div>
                <div v-if="activeSearch" class="uk-form-label uk-margin-top">Search By:</div>
                <div v-if="activeSearch" class="uk-margin uk-grid-medium uk-child-width-auto uk-grid">
                    <div class="uk-width-1-2@l">
                        <label class="uk-display-block">
                            <input class="uk-radio" type="radio" value="name" v-model="selectedFilter" />
                            Name
                        </label>
                        <label class="uk-display-block">
                            <input class="uk-radio" type="radio" value="emp" v-model="selectedFilter" />
                            Employee #
                        </label>
                        <label class="uk-display-block">
                            <input class="uk-radio" type="radio" value="ssn" v-model="selectedFilter" />
                            SSN (Last 4)
                        </label>
                        <label class="uk-display-block">
                            <input class="uk-radio" type="radio" value="craft" v-model="selectedFilter" />
                            Craft
                        </label>
                        <label class="uk-display-block">
                            <input class="uk-radio" type="radio" value="certification" v-model="selectedFilter" />
                            Certification
                        </label>
                        <label class="uk-display-block">
                            <input class="uk-radio" type="radio" value="training" v-model="selectedFilter" />
                            Training
                        </label>
                        <label class="uk-display-block">
                            <input class="uk-radio" type="radio" value="phone" v-model="selectedFilter" />
                            Phone #
                        </label>
                    </div>
                    <div class="uk-width-1-2@l ">
                        <button v-if="!searching" class="uk-button uk-button-primary uk-align-right" @click="startSearch">
                            Search
                        </button>
                        <span v-if="searching" class="uk-align-right">
                            <img style="width: 18px;" src="/images/spinner2.gif" /> Searching...
                        </span>
                    </div>
                    <div class="uk-width-1-2@l">
                        <label>
                            Include Deleted
                            <input class="uk-checkbox" type="checkbox" v-model="includeDeleted" />
                        </label>
                    </div>
                </div>
            </div>
            <div class="uk-width-1-3@xl uk-width-1-2@s uk-margin-small-bottom">
                <div class="uk-form-label">Filter</div>
                <div>
                    Craft:
                    <div class="uk-select uk-margin-small-left uk-width-3-4" style="display:inline-block">SELECT CRAFTS</div>
                    <div uk-dropdown>
                        <div v-for="val in craftOptions">
                            <label><input :key="'craft_' + val.id" class="uk-checkbox" type="checkbox" :value="val.id"
                                          v-model="craftIds"> {{ val.name }}</label>
                        </div>
                    </div>

                </div>
                <div class="uk-margin-top">
                    Business Unit:
                    <div class="uk-select uk-margin-small-left uk-width-2-3" style="display:inline-block">SELECT BUSINESS UNIT</div>
                    <div uk-dropdown>
                        <div v-for="val in buOptions">
                            <label><input :key="'craft_' + val.id" class="uk-checkbox" type="checkbox" :value="val.id"
                                          v-model="buIds"> {{ val.name }}</label>
                        </div>
                    </div>
                </div>
                <div class="uk-margin-top">
                    State:
                    <select class="uk-select uk-width-auto" v-model="state">
                        <option value="">-- Select State --</option>
                        <option v-for="(name, code) in states" :value="code">{{ name }}</option>
                    </select>
                </div>
            </div>
            <div class="uk-width-1-6@xl uk-width-1-2@s uk-margin-small-bottom">
                <div class="uk-form-controls">
                    <input id="pf-category" type="text" name="pf-category" value="" class="uk-input" v-model="searchCategory" placeholder="Enter Rating Type" />
                </div>
                <div class="uk-margin-top">
                    <select class="uk-select" v-model="selectedRatingCategory">
                        <option  value="">-- SELECT Rating Category --</option>
                        <option  v-for="rc in ratingCategories" :value="rc">{{ rc }}</option>
                    </select>
                </div>
                <div class="uk-margin-top">
                    Rating:
                    <select class="uk-select uk-width-1-4" v-model="lowRating">
                        <option v-for="val in ratingValues" :value="val" >{{val}}</option>
                    </select>
                    <select class="uk-select uk-width-1-4" v-model="highRating">
                        <option v-for="val in ratingValues" :value="val" >{{val}}</option>
                    </select>
                </div>
                <div class="uk-form-label uk-margin-top">Records Per Page</div>
                <select class="uk-select uk-width-1-4" v-model="perPage">
                    <option v-for="val in recordOptions" :value="val" >{{val}}</option>
                </select>
                <div class="uk-margin-top">
                    <button class="uk-button uk-button-small uk-margin-small-bottom" @click="clearFilters()">Clear Search/Filters</button>
                </div>
            </div>
            <div class="uk-width-1-4@xl uk-width-1-2@s uk-text-right">
                <button class="uk-button uk-button-tertiary uk-margin-small-bottom" uk-toggle="target: #person-export" @click="openExporter"><i class="fas fa-caret-square-down"></i>Export</button>
                <button class="uk-button uk-button-tertiary uk-margin-small-left uk-margin-small-bottom" @click="showMessageBox" uk-toggle="target: #mass-message-modal">
                    <i class="fas fa-comment"></i>Bulk Message
                </button>
                <div>
                    <!--span v-for="rc in ratingCategories" class="rating-category" @click="setRatingSearch(rc)">
                        {{ rc }}
                    </span -->
                </div>
            </div>
        </div>
        <data-table
                ref="personTable"
                :searchable="false"
                api_point="employee/list"
                :per_page=perPage
                :table_headers="tableFields"
                :size_content="true"
                multi_select=true
                storage-location="person_table"
        ></data-table>
        <message-form ref="message_form" modal-id="mass-message-modal"></message-form>
        <div id="person-export" uk-modal class="requisition-export">
            <div class="uk-modal-dialog uk-modal-body">
                <h2 class="uk-modal-title uk-margin-medium-bottom">Batch Export
                    <div v-if="!all_items" class="uk-align-right@m uk-margin-remove-bottom recipients">
                        {{ selectedPersonIds.length }} Records Selected
                    </div>
                    <div v-if="all_items" class="uk-align-right@m uk-margin-remove-bottom recipients">
                        All Records Selected
                    </div>
                </h2>

                <div class="uk-clearfix"></div>
                <form action="/employees/export" enctype="multipart/form-data" target="_blank" method="post">
                    <label class="uk-form-label header">Select columns to include</label>
                    <input type="hidden" name="_token" v-model="csrf">
                    <input type="hidden" name="person_ids" v-model="person_ids" />
                    <input type="hidden" v-if="all_items" name="all_items" value="1" />
                    <input type="hidden" name="q" v-model="this.searchTerm" />
                    <input type="hidden" name="filters" v-model="this.checkedFilters.join(',')" />
                    <input type="hidden" name="ratingCategory" v-model="this.searchCategory" />
                    <input type="hidden" name="lowRating" v-model="this.lowRating" />
                    <input type="hidden" name="highRating" v-model="this.highRating" />
                    <input type="hidden" name="craftIds" v-model="this.craftIds.join(',')" />
                    <input type="hidden" name="buIds" v-model="this.buIds.join(',')" />
                    <input type="hidden" name="state" v-model="this.state" />

                    <div class="uk-form-controls fields">
                        <label>
                            Number
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="id_number" checked />
                        </label>
                        <label>
                            Name
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="full_name" checked />
                        </label>
                        <label>
                            Social Security #
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="ssn" checked />
                        </label>

                        <label>
                            Birth Date
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="birth_date" checked />
                        </label>
                        <label>
                            Address
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="location" checked />
                        </label>
                        <label>
                            Phone
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="phone" checked />
                        </label>
                        <label>
                            Email
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="email" checked />
                        </label>
                        <label>
                            Hire Date
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="application_date" checked />
                        </label>
                        <label>
                            Union
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="union" checked />
                        </label>
                        <label>
                            Business Unit
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="business_unit" checked />
                        </label>
                        <label>
                            Craft(s)
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="crafts" checked />
                        </label>
                        <label>
                            Training(s)
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="trainings" checked />
                        </label>
                        <label>
                            Certification(s)
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="certifications" checked />
                        </label>
                    </div>
                    <div class="uk-margin-medium-bottom"></div>
                    <div class="uk-align-right">
                        <button class="uk-button uk-button-tertiary uk-modal-close" type="button"><i class="fas fa-times-circle"></i> Cancel</button>
                        <button class="uk-button uk-button-primary" type="submit"><i class="fas fa-caret-square-down"></i> Export to CSV</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
    // import any required components
    import DataTable from "../Table/DataTable";
    import MessageForm from "../ModalForms/MessageForm";
    import GlobalStorage from "../../Classes/GlobalStorage";

    // export component
    export default {
        props: {
            csrf:{type:String},
            displayHours:{type:Boolean, default:false},
            activeSearch:{type:Boolean, default:true},
			displayRating:{type:Boolean, default:true},
        },

        components: {
            DataTable,
            MessageForm
        },

        data() {
            return {
                useAPI: true,
                perPage: 30,
                ratingValues: [1,2,3,4,5],
                lowRating: 1,
                highRating: 5,
                recordOptions: [10,15,30,50],
                buOptions: [],
                buIds:[],
                craftIds: [],
                craftOptions: [],
                checkedFilters: [],
                selectedFilter:"name",
                includeDeleted: false,
                searching: false,
                searchTerm: "",
                searchCategory: "",
                typeCount: 0,
                selectedPersonIds: [],
                person_ids: [],
                states:{},
                state:"",
                all_items: false,
                storageName:"person_settings_v2",
                loadingStorage: false,
                //note: tableFields gets replaced in other places
                tableFields: {id_number:{display:'Employee Number',route:'/employees/view/{id}',sortBy:"paylocity_number",sortable:true},
                    full_name:{display:'Employee Name',route:'/employees/view/{id}'},
                    phone:{display:'Contact Phone'},
                    "location.city":{display:'City', sortable: false},
                    "location.state": {display:'ST', sortable: false},
                    crafts: {display:'Craft(s)', component: "NameClusterCell", sortable:false},
                    certifications: {display:'Certification(s)', component: "NameClusterCell", sortable:false},
                    "business_unit.name": {display:'Business Unit', sortable: false},
                    available_date: {display:'Availability', sortable: false},
                    average_rating: {display:'Rating'},
                    notes: {display: 'Notes',sortable: false}
                },
                ratingCategories: [],
                selectedRatingCategory: ""
            };
        },

        mounted(){
            this.updateTableFields();
            this.loadCrafts();
            this.loadStates();
            this.loadBusinessUnits();
            this.loadStorage();
            this.loadRatingCategories();
            this.$refs.personTable.setPreSearchCallback(this.searchStarting);
            this.$refs.personTable.setSearchCallback(this.searchComplete);
            this.compileFilters();
        },

        methods: {
            startSearch(){
                this.saveStorage();
                this.$refs.personTable.startCustomSearch({
                        "q" :this.searchTerm,
                        "filters": this.checkedFilters,
                        "ratingCategory": this.searchCategory,
                        "lowRating": this.lowRating,
                        "highRating": this.highRating,
                        "craftIds": this.craftIds,
                        "buIds": this.buIds,
                        "state": this.state
                    }
                );
            },
            searchStarting(){
                this.searching = true;
            },
            searchComplete(){
                this.searching = false;
                this.updateTableFields();
            },
            apiSearch(){
                this.typeCount--;
                if(this.typeCount <= 0){
                    !this.loadingStorage ? this.startSearch():null;
                    this.loadingStorage = false;
                }
            },
            clearFilters(){
                this.searchTerm = "";
                this.searchCategory = "";
                this.checkedFilters = [];
                this.selectedFilter = "name";
                this.includeDeleted = false;
                this.lowRating = 1;
                this.highRating = 5;
                this.buIds = [];
                this.craftIds = [];
                this.state = "";
                this.$refs["personTable"].clearStorage();
                this.compileFilters();
                GlobalStorage.save(this.storageName, null); //force clearing out in case it gets "stuck"
            },
            loadBusinessUnits(){
                axios.get("/api/bu/list")
                    .then((pack) => this.updateBuData(pack));
            },
            loadCrafts(){
                axios.get("/api/craft/list/all")
                    .then((pack) => this.updateCraftData(pack));
            },
            loadStates(){
                axios.get("/api/forms/states")
                    .then((pack) => this.updateStateList(pack));
            },
            loadRatingCategories(){
                axios.get("/api/forms/ratings")
                    .then((pack) => this.updateRatingCategories(pack));
            },
            updateBuData(pack){
                let dt = pack.data.data;
                this.buOptions = dt;
            },
            updateCraftData(pack){
                let dt = pack.data.data;
                this.craftOptions = dt;
            },
            updateStateList(pack) {
                if(pack.data.success){
                    this.states = pack.data.data;
                }
            },
            updateRatingCategories(pack){
                if(pack.data.success){
                    this.ratingCategories = pack.data.data;
                }
            },
            setRatingSearch(name){
                if(this.searchCategory.trim().length > 0){
                    this.searchCategory += ", " + name;
                } else {
                    this.searchCategory = name;
                }
            },
            showMessageBox(){
                if(this.$refs.personTable.allSelected){
                    this.$refs.message_form.setFilterCriteria({
                        q: this.searchTerm,
                        filters: this.checkedFilters.join(","),
                        lowRating: this.lowRating,
                        highRating: this.highRating,
                        craftIds: this.craftIds,
                        state: this.state,
                    });
                } else {
                    this.$refs.message_form.setSendIds(Array.from(new Set(
                        this.$refs.personTable.selectedRows
                    )));
                }

            },
            openExporter(){
                this.selectedPersonIds = Array.from(new Set(
                    this.$refs.personTable.selectedRows
                ));
                this.person_ids = this.selectedPersonIds.join(",");
                this.all_items = this.$refs.personTable.allSelected;
            },
            loadStorage(){
                if(GlobalStorage.has(this.storageName)){
                    this.loadingStorage = true;
                    let storedData = GlobalStorage.load(this.storageName);
                    this.searchTerm = storedData.searchTerm;
                    this.searchCategory = storedData.searchCategory;
                    this.checkedFilters = storedData.checkedFilters;
                    this.craftIds = storedData.craftIds ? storedData.craftIds:[];
                    this.buIds = storedData.buIds ? storedData.buIds:[];
                    this.lowRating = storedData.lowRating;
                    this.highRating = storedData.highRating;
                    this.state = storedData.state;
                    this.perPage = storedData.perPage;
                    if(this.checkedFilters.length > 0){
                        this.selectedFilter = this.checkedFilters[0];
                    }
                    if(this.checkedFilters.length > 1 && this.checkedFilters.includes("include_deleted")){
                        this.includeDeleted = true;
                    }
                }
            },
            saveStorage(){
                let data = {
                    searchTerm: this.searchTerm,
                    searchCategory: this.searchCategory,
                    checkedFilters: this.checkedFilters,
                    craftIds: this.craftIds,
                    buIds: this.buIds,
                    lowRating: this.lowRating,
                    highRating: this.highRating,
                    state: this.state,
                    perPage: this.perPage
                };
                GlobalStorage.save(this.storageName, data);
            },
            compileFilters(){
                if(!this.activeSearch){return;}
                this.checkedFilters = [this.selectedFilter];
                if(this.includeDeleted){
                    this.checkedFilters.push("include_deleted");
                }
            },

            updateTableFields(){
                if(this.displayHours && this.displayRating){
                    this.tableFields = {id_number:{display:'Employee Number',route:'/employees/view/{id}',sortBy:"paylocity_number",sortable:true},
                        full_name:{display:'Employee Name',route:'/employees/view/{id}'},
                        phone:{display:'Contact Phone'},
                        "location.city":{display:'City', sortable: false},
                        "location.state": {display:'ST', sortable: false},
                        crafts: {display:'Craft(s)', component: "NameClusterCell", sortable:false},
                        certifications: {display:'Certification(s)', component: "NameClusterCell", sortable:false},
                        "business_unit.name": {display:'Business Unit', sortable: false},
                        total_hours: {display:'Worked Hours'},
                        available_date: {display:'Availability', sortable: false},
                        average_rating: {display:'Rating'},
                        notes: {display: 'Notes',sortable: false}
                    }
                }
				else if(!this.displayHours && this.displayRating){
					this.tableFields = {id_number:{display:'Employee Number',route:'/employees/view/{id}',sortBy:"paylocity_number",sortable:true},
						full_name:{display:'Employee Name',route:'/employees/view/{id}'},
						phone:{display:'Contact Phone'},
						"location.city":{display:'City', sortable: false},
						"location.state": {display:'ST', sortable: false},
						crafts: {display:'Craft(s)', component: "NameClusterCell", sortable:false},
						certifications: {display:'Certification(s)', component: "NameClusterCell", sortable:false},
						"business_unit.name": {display:'Business Unit', sortable: false},
						available_date: {display:'Availability', sortable: false},
						average_rating: {display:'Rating'},
						notes: {display: 'Notes',sortable: false}
					}
				}
				else if(this.displayHours && !this.displayRating){
					this.tableFields = {id_number:{display:'Employee Number',route:'/employees/view/{id}',sortBy:"paylocity_number",sortable:true},
						full_name:{display:'Employee Name',route:'/employees/view/{id}'},
						phone:{display:'Contact Phone'},
						"location.city":{display:'City', sortable: false},
						"location.state": {display:'ST', sortable: false},
						crafts: {display:'Craft(s)', component: "NameClusterCell", sortable:false},
						certifications: {display:'Certification(s)', component: "NameClusterCell", sortable:false},
						"business_unit.name": {display:'Business Unit', sortable: false},
						total_hours: {display:'Worked Hours'},
						available_date: {display:'Availability', sortable: false},
						notes: {display: 'Notes',sortable: false}
					}
				}
				else {//both are false, don't display either
                    this.tableFields = {id_number:{display:'Employee Number',route:'/employees/view/{id}',sortBy:"paylocity_number",sortable:true},
                        full_name:{display:'Employee Name',route:'/employees/view/{id}'},
                        phone:{display:'Contact Phone'},
                        "location.city":{display:'City', sortable: false},
                        "location.state": {display:'ST', sortable: false},
                        crafts: {display:'Craft(s)', component: "NameClusterCell", sortable:false},
                        certifications: {display:'Certification(s)', component: "NameClusterCell", sortable:false},
                        "business_unit.name": {display:'Business Unit', sortable: false},
                        available_date: {display:'Availability', sortable: false},
                        notes: {display: 'Notes',sortable: false}
                    }
                }

                if(this.searchCategory.length > 0){
                    let firstPerson = this.$refs.personTable.list_rows[0];
                    if(firstPerson.ratingAverages){
                        delete this.tableFields.notes;
                        for(name in firstPerson.ratingAverages){
                            let displayName = name.replace("_", " ");
                            this.tableFields["ratingAverages." + name] = {
                                display: displayName,
                                sortable: false
                            };
                        }
                        this.tableFields.notes = {display: 'Notes',sortable: false};
                    }
                }
                //this.$refs.personTable.createRenderedData();
            },
			checkSearch(e){
            	if(e.keyCode == 13){
            		this.startSearch();
				}
			}
        },

        watch: {
            searchTerm() {
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }

            },
            searchCategory() {
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    //let this one be a little longer; will likely be intensive
                    setTimeout(() => this.apiSearch(), 600);
                } else {
                    this.startSearch();
                }
            },
            lowRating() {
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            highRating() {
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            checkedFilters: {
                deep:true,
                handler(){
                    if(this.activeSearch){
                        return;
                    }
                    if (this.useAPI) {
                        this.typeCount++;
                        setTimeout(() => this.apiSearch(), 400);
                    } else {
                        this.startSearch();
                    }
                }
            },
            perPage() {
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            craftIds(){
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            buIds(){
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            state(){
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            selectedFilter(){
                this.compileFilters();
            },
            includeDeleted(){
                this.compileFilters();
            },
            selectedRatingCategory(val){
                this.setRatingSearch(val);
            }
        }
    };

</script>
<style lang="less" scoped>
    .rating-category{
        cursor: pointer;
        padding: 0 4px;
        border: thin solid #7d7d7d;
        border-radius: 2px;
        display: inline-block;
        margin: 2px;
        font-size: 12px;
        &:hover{
            border-color: #484848;
        }
    }
</style>
